var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { onAttributeValueChange, validateAndFormatAttributeValue } from '../../../redux/alertsForm/actions';
import { FAS_CIRCLE_EXCLAMATION, FAS_DOLLAR_SIGN } from '../../../const/iconProps';
import { CustomTextField, CustomTextFieldWrapper } from './subcomponents';
// match from start to end digits, comma, and periods only
var VALID_CURRENCY_CHARACTERS_REGEX = /^(\d|\.|,)*$/;
// match any non digit character globally
var REPLACE_NUMBERS_ONLY_REGEX = /\D/g;
var INPUT_MAX_VALUE = 99999;
var AlertTextField = function (_a) {
    var alertId = _a.alertId, inputKey = _a.inputKey, inputValue = _a.inputValue, inputError = _a.inputError, inputRef = _a.inputRef;
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var stringKey = alertId.toLowerCase();
    var _b = useState(false), shouldChangeCaretPosition = _b[0], setShouldChangeCaretPosition = _b[1];
    var _c = useState(0), caretPosition = _c[0], setCaretPosition = _c[1];
    var _d = useState(null), inputElementEvent = _d[0], setInputElementEvent = _d[1];
    var updateInputValue = useCallback(function (value) {
        dispatch(onAttributeValueChange(alertId, inputKey, value));
    }, [alertId, dispatch, inputKey]);
    // This function will move the caret
    var moveCaretPosition = useCallback(function () {
        if (shouldChangeCaretPosition) {
            inputElementEvent.setSelectionRange(caretPosition, caretPosition);
            setShouldChangeCaretPosition(false);
        }
    }, [
        shouldChangeCaretPosition,
        inputElementEvent,
        caretPosition,
        setShouldChangeCaretPosition
    ]);
    /*
     * Every time formattedInput changes, we check:
     * - if we need to move the caret
     * - update Single Alert State input value
     */
    useEffect(function () {
        moveCaretPosition();
        // updateSingleAlertInputValue()
    }, [inputValue, moveCaretPosition]);
    var onChangeHandler = useCallback(function (e) {
        var _a;
        var element = e.currentTarget;
        var currentCaretPosition = element.selectionStart;
        var value = element.value;
        var preventInputValue = function () {
            e.preventDefault();
            setInputElementEvent(element);
            // we subtract 1 here to put caret position back to where it was prior to user input
            setCaretPosition(currentCaretPosition - 1);
            setShouldChangeCaretPosition(true);
        };
        if (!VALID_CURRENCY_CHARACTERS_REGEX.test(value)) {
            preventInputValue();
            return;
        }
        var wholeNumber = Number((_a = value === null || value === void 0 ? void 0 : value.split('.')[0]) === null || _a === void 0 ? void 0 : _a.replace(REPLACE_NUMBERS_ONLY_REGEX, ''));
        if (wholeNumber > INPUT_MAX_VALUE) {
            preventInputValue();
            return;
        }
        updateInputValue(value);
    }, [updateInputValue]);
    var onBlurHandler = useCallback(function () {
        if (inputValue === '') {
            return;
        }
        dispatch(validateAndFormatAttributeValue(alertId, inputKey));
    }, [inputValue, dispatch, alertId, inputKey]);
    var onFocusHandler = useCallback(function (e) {
        if (e.currentTarget.value === '') {
            // Set Caret to beginning of input since we are auto adding .00
            setInputElementEvent(e.currentTarget);
            setCaretPosition(0);
            setShouldChangeCaretPosition(true);
        }
    }, []);
    var onKeyPressHandler = useCallback(function (e) {
        var element = e.currentTarget;
        // if we press . (period) we find the index of it and put the caret to the right of the . (period)
        if (e.key === '.' && (inputValue === null || inputValue === void 0 ? void 0 : inputValue.includes('.'))) {
            var decimalIndex = inputValue.indexOf('.') + 1;
            e.preventDefault();
            element.setSelectionRange(decimalIndex, decimalIndex);
        }
    }, [inputValue]);
    return (_jsx(CustomTextFieldWrapper, __assign({ "data-test": "CustomTextFieldWrapper" }, { children: _jsx(CustomTextField, { required: true, id: "amount-".concat(alertId), textfieldRef: inputRef, "data-test": "CustomTextField", autoCapitalize: "none", name: "amount", placeholder: t("inputPlaceHolders.".concat(stringKey)), helpText: t("inputHelperText.".concat(stringKey)) || '', error: inputError, errorIcon: _jsx(FontAwesomeIcon, { icon: FAS_CIRCLE_EXCLAMATION }), leftIcon: _jsx(FontAwesomeIcon, { icon: FAS_DOLLAR_SIGN, height: "16px" }), type: "text", value: inputValue, onKeyPress: onKeyPressHandler, onFocus: onFocusHandler, onChange: onChangeHandler, onBlur: onBlurHandler }) })));
};
export default AlertTextField;
